import { bySport } from "../../../common/index.ts";
import limitRating from "./limitRating.ts";

const heightToRating = (heightInInches: number) => {
	const minHgt = bySport({
		baseball: 62, // 5'2"
		basketball: 66, // 5'6"
		football: 64, // 5'4"
		hockey: 62, // 5'2"
	});

	const maxHgt = bySport({
		baseball: 82, // 6'10"
		basketball: 93, // 7'9"
		football: 82, // 6'10"
		hockey: 82, // 6'10"
	});

	return limitRating((100 * (heightInInches - minHgt)) / (maxHgt - minHgt));
};

export default heightToRating;
